function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.42 17.38C6 13.26 4.97 8.68 4 7c2.7 1.25 4.44 8.27 5.26 14H6.63v-.04L5.8 21s-.2-5.06-2.54-7c1.48.55 2.47 1.84 3.16 3.38zm6.5 3.4c.02.07.03.14.03.22h-2.73c0-5.53-2.25-14.68-3.22-17 1.76 1 3.4 5 4.57 9.6.78-3.23 1.84-5.87 3.4-6.6-.95 1.9-2 9.16-2.04 13.77zm4-2.4C17.25 14.68 18.2 8.1 20.8 5c-4.06 2.18-5.9 9.5-6.8 16h4.72s.2-5.06 2.54-7c-1.77.66-3.35 2.4-4.34 4.37z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationGrass = function SvgLocationGrass(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationGrass;